/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Plan_ConsidersInputs */

const en_us2_profile_plan_considers = /** @type {(inputs: Profile_Plan_ConsidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What the plan takes into account`)
};

const pt_br2_profile_plan_considers = /** @type {(inputs: Profile_Plan_ConsidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que o plano leva em conta`)
};

const es_419_profile_plan_considers = /** @type {(inputs: Profile_Plan_ConsidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lo que el plan tiene en cuenta`)
};

const pt_pt2_profile_plan_considers = /** @type {(inputs: Profile_Plan_ConsidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O que o plano tem em conta`)
};

const fr_fr2_profile_plan_considers = /** @type {(inputs: Profile_Plan_ConsidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ce que le programme prend en compte`)
};

const de_de2_profile_plan_considers = /** @type {(inputs: Profile_Plan_ConsidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was der Plan berücksichtigt`)
};

const it_it2_profile_plan_considers = /** @type {(inputs: Profile_Plan_ConsidersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cosa considera la scheda`)
};

/**
* | output |
* | --- |
* | "What the plan takes into account" |
*
* @param {Profile_Plan_ConsidersInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_plan_considers = /** @type {((inputs?: Profile_Plan_ConsidersInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Plan_ConsidersInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_plan_considers(inputs)
	if (locale === "es-419") return es_419_profile_plan_considers(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_plan_considers(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_plan_considers(inputs)
	if (locale === "de-DE") return de_de2_profile_plan_considers(inputs)
	if (locale === "it-IT") return it_it2_profile_plan_considers(inputs)
	return en_us2_profile_plan_considers(inputs)
});
export { profile_plan_considers as "profile.plan_considers" }